import { Typography, notification } from "antd";

export const CallbackMessage = ({
	message,
	description = null,
	type = "success",
	duration = 4.5,
}: {
	message: string;
	description?: string;
	type?: "success" | "error";
	duration?: number;
}) => {
	const options = {
		message: <Typography.Text strong>{message}</Typography.Text>,
		description: description,
		style: { maxWidth: "calc(100% - 16px)" },
		duration: duration,
	};

	if (type == "error") return notification.error(options);
	else return notification.success(options);
};
